module.exports = __webpack_public_path__ + "img/m-banner-12m.64e5381d.png";